var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotsOptionsHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C4 0.9 3.1 -1.35505e-07 2 -8.74228e-08C0.9 -3.93403e-08 -1.35505e-07 0.9 -8.74228e-08 2C-3.93403e-08 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2ZM6 2C6 3.1 6.9 4 8 4C9.1 4 10 3.1 10 2C10 0.899999 9.1 -3.97774e-07 8 -3.49691e-07C6.9 -3.01609e-07 6 0.9 6 2ZM14 4C12.9 4 12 3.1 12 2C12 0.899999 12.9 -5.63877e-07 14 -6.11959e-07C15.1 -6.60042e-07 16 0.899999 16 2C16 3.1 15.1 4 14 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsOptionsHorizontal);
export default __webpack_public_path__ + "static/media/three-dots-options-horizontal.42d10f1f59bd884ee462c48e7d7808f7.svg";
export { ForwardRef as ReactComponent };